
















































































































import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { IPageConfig } from "@/@types/filoxenia-config/nav-bar";
import { configuration } from "@/config/host.config";

import HotelConfigurationDemo from "@/components/demo/main/hotel-configuration-demo.vue";
import MainDemo from "@/components/demo/main-demo.vue";
import StandartModal from "@/components/app/standart-modal.vue";
import draggable from "vuedraggable";

@Component({
  components: {
    StandartModal,
    HotelConfigurationDemo,
    MainDemo,
    draggable,
  },
})
export default class TvMenuConfig extends Vue {
  @Prop({ type: String, default: "" }) background!: string;
  @Inject({ from: "backgroundFolder", default: "" }) readonly folder!: string;

  enabled = true;
  dragging = false;
  navList: Array<IPageConfig> = [];

  get home_main(): Array<IPageConfig> {
    return this.navList.filter((el) => {
      if (el.nav == "home_main") return el;
    });
  }

  get home_min(): Array<IPageConfig> {
    return this.navList.filter((el) => {
      if (el.nav == "home_min") return el;
    });
  }

  isChangeShow(id: string): void {
    const i = this.navList.findIndex((el) => el._id == id);

    if (i < 0 || this.navList[i].lock) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
      return;
    }

    this.$set(this.navList[i], "show", !this.navList[i].show);
    if (!this.navList[i].show) {
      this.$set(this.navList[i], "active", false);
      this.$set(this.navList[i], "nav", "");
    }
    const data: Partial<IPageConfig> = {
      show: this.navList[i].show,
      active: this.navList[i].active,
      nav: this.navList[i].nav,
    };

    this.updateNav(data, id);
  }

  isChangeHomeActive(id: string): void {
    const i = this.navList.findIndex((el) => el._id == id);

    if (i < 0 || this.navList[i].lock) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
      return;
    }

    this.$set(this.navList[i], "active", !this.navList[i].active);
    if (this.navList[i].active) this.$set(this.navList[i], "show", true);

    const menu = !this.navList[i].nav
      ? this.home_main.length < 12
        ? "home_main"
        : "home_min"
      : this.navList[i].active
      ? this.navList[i].nav
      : "";
    this.$set(this.navList[i], "nav", menu);

    const data: Partial<IPageConfig> = {
      show: this.navList[i].show,
      active: this.navList[i].active,
      nav: this.navList[i].nav,
    };

    this.updateNav(data, id);
  }

  changeNavMenu(id: string, menu: string): void {
    const page = this.navList.find((el) => el._id == id);
    if (!page) return;
    const nav = page.nav;
    if (menu == "home_main")
      if (this.home_main.length >= 12) {
        const pagedown = this.navList.find(
          (el) => el._id == this.home_main[this.home_main.length - 1]._id
        );
        if (pagedown) {
          this.$set(pagedown, "nav", nav);
          this.updateNav({ nav }, pagedown._id);
        }
      }

    this.$set(page, "nav", menu);
    this.updateNav({ nav: page.nav }, id);
    if (menu == "home_min") {
      const pagedown = this.navList.find(
        (el) => el._id == this.home_min[1]._id
      );
      if (pagedown) {
        this.$set(pagedown, "nav", nav);
        this.updateNav({ nav }, pagedown._id);
      }
    }
  }

  updatemain(arr: Array<IPageConfig>): void {
    const other = this.navList.filter((el) => {
      if (el.nav != "home_main" && el.nav != "home_min") return el;
    });
    const routes = arr.concat(this.home_min).concat(other);
    this.navList = routes;
    this.changeSortOrders();
  }

  updatemin(arr: Array<IPageConfig>): void {
    const other = this.navList.filter((el) => {
      if (el.nav != "home_main" && el.nav != "home_min") return el;
    });
    const routes = this.home_main.concat(arr).concat(other);
    this.navList = routes;
    this.changeSortOrders();
  }

  changeSortOrders(): void {
    for (let i = 0; i < this.navList.length; i++) {
      if (this.navList[i].sort_order == i) continue;
      this.$set(this.navList[i], "sort_order", i);
      this.updateNav({ sort_order: i }, this.navList[i]._id);
    }
  }

  async createNavList(): Promise<void> {
    const uri = configuration.pages.main;
    try {
      const res = await this.$axios.get(uri);
      if (res.status == 200)
        this.navList = this.$getRootPermition()
          ? res.data
          : res.data.filter((el: IPageConfig) => {
              if (el.show) return el;
            });
    } catch (e) {
      console.log("create n av list error");
      console.error(e);
    }
  }

  async updateNav(data: Partial<IPageConfig>, id: string): Promise<void> {
    const uri = configuration.pages.main + "/" + id;
    try {
      const resnav = await this.$axios.put(uri, data);
      if (resnav.status === 200) {
        const i = this.navList.findIndex((el) => el._id == id);
        if (i < 0) return this.createNavList();
        this.$set(this.navList, i, resnav.data);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
      }
    } catch (error) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
      console.error(error);
    }
  }

  mounted(): void {
    this.createNavList();
  }
}
